import {Toggle} from "./Toggle"
import ToolTip from "./ToolTip"
import {useDisplay} from '../../context'

export const DisplayToggles = () => {
    const {displayY1, displayY2, displayY3, displayAverage, setY1, setY2, setY3, setAv} = useDisplay()
    const currentYear = new Date().getFullYear()

    return (
    <div className="is-flex is-justify-content-center" style={{marginTop: ".5rem"}}>
        <Toggle isOn={displayY1} handleToggle={setY1} text={currentYear} />
        <Toggle isOn={displayY2} handleToggle={setY2} text={currentYear + 1} />
        <Toggle isOn={displayY3} handleToggle={setY3} text={currentYear + 2} />
        <Toggle isOn={displayAverage} handleToggle={setAv} text={"Average"} />
        <ToolTip text={["Values are calculated on a three year total. If you are interested in seeing the breakdown per year, these boxes can be toggled on and off"]} />
    </div>
    )
}